import React from 'react';
import { AuctionCreditBalanceCardMap } from '../maps';
import DefaultAuctionCreditBalanceCard from './default';

export function AuctionCreditBalanceCardModule({ publisher_id, ...props }) {
  const Component =
    AuctionCreditBalanceCardMap[publisher_id] || DefaultAuctionCreditBalanceCard;

  return <Component {...props} />;
}
